import { useTranslation } from 'react-i18next';
import { withLocalize } from '../hoc/with-localize';
import UniCreditTextButton, { type UniCreditTextButtonProps } from '../uni-credit-text-button';

import { LINK_BANK_FIND_OFFICE } from './constants';

function UniCreditFindBankOffice(props: UniCreditTextButtonProps) {
  const { t } = useTranslation();

  return (
    <UniCreditTextButton href={LINK_BANK_FIND_OFFICE}
      endArrow={!props.component}
      {...props}
    >
      {t('findBankOffice')}
    </UniCreditTextButton>
  );
}

export default withLocalize(UniCreditFindBankOffice);
